import { useDispatch } from 'react-redux';
import { customerSlice } from '../../..';

type LogoutCustomerEffectReturn = {
  logoutCustomer: () => void;
};

export const useLogoutCustomerEffect = (): LogoutCustomerEffectReturn => {
  const dispatch = useDispatch();

  const logoutCustomer = (): void => {
    dispatch(customerSlice.actions.sse(false));
    dispatch(customerSlice.actions.logout());
  };

  return { logoutCustomer };
};
